(function () {
  'use strict';

  var DEFAULT_EDITOR_BASE = 'https://deinspar-maps.vercel.app';

  var SUPPORTED_MARKET_LOCALES = {
    'de-de': true,
    'de-at': true,
    'de-ch': true,
    'fr-ch': true,
    'it-ch': true,
    'fr-fr': true,
    'nl-nl': true,
    'es-es': true,
    'it-it': true,
    'da-dk': true,
    'fr-be': true,
    'nl-be': true,
    'de-be': true,
    'fr-lu': true,
    'en-pl': true,
    'en-ie': true,
    'no-no': true,
    'en-pt': true,
    'en-hr': true,
    'en-si': true,
    'en-hu': true,
    'en-bg': true,
    'en-ee': true,
    'en-gr': true,
    'en-cz': true,
    'en-fi': true,
    'en-ca': true,
    'en-us': true,
    'en-nz': true,
    'en-au': true,
    'en-jp': true
  };

  var embed = null;
  var frame = null;
  var loading = null;
  var closeButton = null;
  var activeLauncher = null;

  function cleanText(value) {
    return String(value || '').trim();
  }

  function normalizeEditorBase(value) {
    var base = cleanText(value) || DEFAULT_EDITOR_BASE;
    return base.replace(/\/+$/, '');
  }

  function normalizeLocale(value) {
    var locale = cleanText(value)
      .toLowerCase()
      .replace(/_/g, '-')
      .replace(/^\/+|\/+$/g, '');

    if (!locale) return '';

    if (locale === 'nb-no' || locale === 'nn-no') {
      locale = 'no-no';
    }

    return SUPPORTED_MARKET_LOCALES[locale] ? locale : '';
  }

  function localeFromPath(pathname) {
    var path = cleanText(pathname);

    if (!path || path === '/') {
      return '';
    }

    var firstSegment = path
      .replace(/^\/+/, '')
      .split('/')[0];

    return normalizeLocale(firstSegment);
  }

  function localeFromShopRoot(root) {
    var value = cleanText(root);

    if (!value || value === '/') {
      return '';
    }

    return localeFromPath(value);
  }

  function localeFromLanguageCountry(language, country) {
    var languageCode = cleanText(language)
      .toLowerCase()
      .replace(/_/g, '-')
      .split('-')[0];

    var countryCode = cleanText(country).toLowerCase();

    if (!languageCode || !countryCode) {
      return '';
    }

    if (countryCode === 'gb' && languageCode === 'en') {
      return '';
    }

    if (
      countryCode === 'no' &&
      (languageCode === 'nb' || languageCode === 'nn' || languageCode === 'no')
    ) {
      return 'no-no';
    }

    return normalizeLocale(languageCode + '-' + countryCode);
  }

  function resolveMarketLocale(button) {
    var routeLocale = localeFromShopRoot(
      button.getAttribute('data-shop-root')
    );

    if (routeLocale) {
      return routeLocale;
    }

    var currentPathLocale = localeFromPath(
      window.location.pathname
    );

    if (currentPathLocale) {
      return currentPathLocale;
    }

    return localeFromLanguageCountry(
      button.getAttribute('data-shop-language'),
      button.getAttribute('data-shop-country')
    );
  }

  function normalizeSizeKey(value) {
    var text = cleanText(value)
      .toLowerCase()
      .replace(/×/g, 'x');

    var match = text.match(/(\d+)\s*x\s*(\d+)/);

    if (!match) {
      return '';
    }

    var key = match[1] + 'x' + match[2];

    if (
      key === '21x30' ||
      key === '30x40' ||
      key === '50x70' ||
      key === '70x100'
    ) {
      return key;
    }

    return '';
  }

  function getSelectedSizeKey() {
    var activeOption = document.querySelector(
      '[data-custom-size-value].is-active'
    );

    if (activeOption) {
      var activeValue = activeOption.getAttribute(
        'data-custom-size-value'
      );

      var activeKey = normalizeSizeKey(activeValue);

      if (activeKey) {
        return activeKey;
      }
    }

    var triggerText = document.querySelector(
      '[data-custom-size-trigger-text]'
    );

    if (triggerText) {
      var triggerKey = normalizeSizeKey(
        triggerText.textContent
      );

      if (triggerKey) {
        return triggerKey;
      }
    }

    return '';
  }

  function buildEditorUrl(button) {
    var base = normalizeEditorBase(
      button.getAttribute('data-editor-base')
    );

    var locale = resolveMarketLocale(button);
    var path = locale ? '/' + locale : '/';
    var target = new URL(base + path);

    target.searchParams.set('embedded', '1');
    target.searchParams.set('source', 'shopify');

    var selectedSize = getSelectedSizeKey();

    if (selectedSize) {
      target.searchParams.set('size', selectedSize);
    }

    return target.toString();
  }

  /*
   * IMPORTANT:
   * The embed is originally rendered inside the product information block,
   * which can live inside Shopify's sticky/stacking contexts.
   *
   * A fixed child cannot out-z-index elements outside an ancestor stacking
   * context. Moving the embed directly below <body> makes it a true page-level
   * overlay and prevents product sliders, sticky bars and market widgets from
   * appearing above the editor.
   */
  function portalEmbedToBody() {
    if (!embed || !document.body) {
      return;
    }

    if (embed.parentElement !== document.body) {
      document.body.appendChild(embed);
    }
  }

  function setLoading(isLoading) {
    if (!loading) return;
    loading.hidden = !isLoading;
  }

  function lockPage() {
    document.documentElement.classList.add(
      'deinspar-map-embed-open'
    );
    document.body.classList.add(
      'deinspar-map-embed-open'
    );
  }

  function unlockPage() {
    document.documentElement.classList.remove(
      'deinspar-map-embed-open'
    );
    document.body.classList.remove(
      'deinspar-map-embed-open'
    );
  }

  function openEditor(button) {
    if (!embed || !frame) return;

    /*
     * Do this on every open as a safety net in case Shopify has re-rendered
     * parts of the product section.
     */
    portalEmbedToBody();

    activeLauncher = button;
    setLoading(true);

    embed.hidden = false;
    embed.setAttribute('aria-hidden', 'false');
    lockPage();

    frame.src = buildEditorUrl(button);

    window.requestAnimationFrame(function () {
      if (closeButton) {
        closeButton.focus({
          preventScroll: true
        });
      }
    });
  }

  function closeEditor() {
    if (!embed || !frame) return;

    embed.hidden = true;
    embed.setAttribute('aria-hidden', 'true');
    frame.src = 'about:blank';
    setLoading(true);
    unlockPage();

    if (activeLauncher) {
      activeLauncher.focus({
        preventScroll: true
      });
    }

    activeLauncher = null;
  }

  function promoteShopifyNavigation() {
    if (!frame || frame.src === 'about:blank') {
      return;
    }

    try {
      var iframeUrl = frame.contentWindow.location.href;

      if (!iframeUrl || iframeUrl === 'about:blank') {
        return;
      }

      var target = new URL(iframeUrl);

      if (target.origin === window.location.origin) {
        window.location.assign(target.href);
      }
    } catch (error) {
      /*
       * Expected while the editor is still on the Vercel origin.
       */
    }
  }

  function initDeinsparMapEmbed() {
    embed = document.querySelector(
      '[data-deinspar-map-embed]'
    );

    frame = document.querySelector(
      '[data-deinspar-map-frame]'
    );

    loading = document.querySelector(
      '[data-deinspar-map-loading]'
    );

    closeButton = document.querySelector(
      '[data-deinspar-map-close]'
    );

    var launchers = document.querySelectorAll(
      '[data-deinspar-map-launch]'
    );

    if (!embed || !frame || !launchers.length) {
      return;
    }

    /*
     * Escape the product section's sticky/stacking context immediately.
     * The embed stays hidden in <body> until the customer opens it.
     */
    portalEmbedToBody();

    launchers.forEach(function (button) {
      button.addEventListener('click', function () {
        openEditor(button);
      });
    });

    if (closeButton) {
      closeButton.addEventListener(
        'click',
        closeEditor
      );
    }

    frame.addEventListener('load', function () {
      setLoading(false);
      promoteShopifyNavigation();
    });

    document.addEventListener('keydown', function (event) {
      if (
        event.key === 'Escape' &&
        !embed.hidden
      ) {
        closeEditor();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initDeinsparMapEmbed,
      { once: true }
    );
  } else {
    initDeinsparMapEmbed();
  }
})();